<div class="wrapper">
	@if (amountOfSlides > 0) {
		<swiper-container
			class="right"
			direction="horizontal"
			swiperElement
			#swiperCategories
			[config]="config"
			[allowTouchMove]="true"
			[slidesPerView]="amountOfSlides"
			(onSlideChange)="slideChange($event)"
			(slideChange)="slideChange($event)"
			[lazyPreloadPrevNext]="20"
			[centeredSlides]="true"
		>
			@for (category of categories; track $index; let last = $last) {
				<swiper-slide class="slide" [id]="$index" (click)="goToIndex($index)">
					<div class="category-wrapper" role="region" aria-label="Category section">
						<ion-chip (click)="selectIndex($index)" class="chip category ion-margin-top ion-margin-bottom" tappable>
							<div class="border-dotted"></div>
							<ion-img class="category-image" *ngIf="category.assets.medium" [src]="category.assets.medium" alt=""> </ion-img>
							<ion-img
								class="category-image"
								*ngIf="!category.assets.medium"
								src="../../../assets/losteria/logo.svg"
								alt=""
								aria-hidden="true"
							>
							</ion-img>
						</ion-chip>
						<!-- <h4 class="category-name" [class.selected]="selectedCategory && category._id === selectedCategory._id">
				{{ category.name | langObservable | async }}
			</h4> -->
						<div class="line-dotted-block" *ngIf="!last" role="region" aria-label="Dotted block line">
							<ion-img src="/assets/losteria/dotted-line.svg" alt="" aria-hidden="true"></ion-img>
						</div>
					</div>
				</swiper-slide>
			}
		</swiper-container>
	}
</div>
